module.exports = __webpack_public_path__ + "img/電気回路_5_10_3.d379d7bf.png";